import { render, staticRenderFns } from "./ServiceSpotMessagesList.vue?vue&type=template&id=075f7be8"
import script from "./ServiceSpotMessagesList.vue?vue&type=script&lang=js"
export * from "./ServiceSpotMessagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports